<script lang="ts">
    import data from "../../../Data/SearchResult/SearchResult.json"
    import Link from "svelte-link";
    import {tempId} from "../../../store"
    import { Card, CardBody, Col, Image, Row } from "sveltestrap";
    let imgPath:string = "/assets/images/lightgallry"
    let setTempid:string
    tempId.subscribe((value)=>{
        setTempid = value
    })
</script>
<div class="tab-pane fade {setTempid === "top-photos" ? "active show" : ""}" id="top-about2" role="tabpanel" aria-labelledby="photos">
    <Row>
        <Col sm="12">
            <Card>
                <CardBody class="row my-gallery gallery-with-description" itemscope>
                    {#each data.imagesdata as searchItem}
                        <Col xl="3" sm="6">
                            <Link href={searchItem.path} >
                                <!-- svelte-ignore a11y-img-redundant-alt -->
                                <Image src="{imgPath}/{searchItem.img}"  alt="Image description" />
                                <div class="caption">
                                    <h4>{searchItem.title}</h4>
                                    <p>{searchItem.detail}</p>
                                </div>
                            </Link>
                        </Col>
                    {/each}
                </CardBody>
            </Card>
        </Col>
    </Row>
</div>